module.exports = __webpack_public_path__ + "fontawesome-webfont-b64486fe24a30dc4af3833753dd6738f.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 78
// module chunks = 0 1